// extracted by mini-css-extract-plugin
export var parcelRow = "_qk-0";